import { ReactNode, useState } from 'react';
import classNames from 'classnames';
import { Typography } from '../typography/typography';

type TabName = {
  name: string;
  count?: number;
};

type TabNavRequest = {
  className?: string;
  tabNames: TabName[];
  selectedTab: string;
  onSelect: (tab: string) => ReactNode;
};

export const TabNavRequest = ({ tabNames, selectedTab, onSelect, className }: TabNavRequest) => {
  const [content, setContent] = useState<ReactNode>(null);

  function onTabChange(tab: string) {
    setContent(onSelect(tab));
  }

  return (
    <div className="m-0">
      <ul
        className={classNames(
          'bg-white min-h-[60px] min-w-full mx-0 mt-[15px] mb-[1px] px-[24px] pt-[24px] gap-[24px] flex items-left list-none overflow-x-auto',
          className,
        )}
      >
        {tabNames.map((tabName: TabName, i) => (
          <li
            key={i}
            className={classNames('cursor-pointer', {
              'border-solid border-0 border-b-2 pb-[12px]': tabName.name === selectedTab,
            })}
            onClick={() => onTabChange(tabName.name)}
          >
            <div className="flex flex-row gap-2 items-center">
              <Typography
                className={classNames('whitespace-nowrap text-[var(--grey-500)] flex flex-row', {
                  '!text-[var(--quipli-black-800)]': tabName.name === selectedTab,
                })}
                weight="semi-bold"
                type="text-sm"
              >
                {tabName.name}
              </Typography>
              {tabName.count !== undefined && <NumberChip tabName={tabName} selectedTab={selectedTab} />}
            </div>
          </li>
        ))}
      </ul>
      <div className="m-0 p-0">{content}</div>
    </div>
  );
};

export const NumberChip = ({ tabName, selectedTab }: { tabName: TabName; selectedTab: string }) => (
  <Typography
    className={classNames('whitespace-nowrap text-[var(--grey-500)] flex flex-row rounded-16', {
      'bg-grey-800 !text-[var(--quipli-white)]': tabName.name === selectedTab,
      'bg-grey-300 !text-[var(--quipli-black-800)]': tabName.name !== selectedTab,
    })}
    weight="semi-bold"
    type="text-sm"
  >
    <div className="p-1 pl-3 pr-3">{tabName.count}</div>
  </Typography>
);
